import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a2d0bb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mandatory" }, null, -1))
const _hoisted_2 = { class: "row q-mt-md q-col-gutter-lg" }
const _hoisted_3 = { class: "col-12 col-md-6" }
const _hoisted_4 = { class: "col-12 col-md-6" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "row full-width" }
const _hoisted_7 = { class: "row q-col-gutter-lg q-pr-lg no-wrap col-12 col-md-7" }
const _hoisted_8 = { class: "col-12 col-md-5" }
const _hoisted_9 = { class: "row q-pt-md" }
const _hoisted_10 = { class: "col-9 input-conference-margin" }
const _hoisted_11 = { class: "ellipsis" }
const _hoisted_12 = { class: "ellipsis" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "ellipsis" }
const _hoisted_15 = { class: "row no-wrap items-center q-gutter-x-sm" }
const _hoisted_16 = { class: "ellipsis" }
const _hoisted_17 = { class: "row no-wrap items-center q-gutter-x-sm" }
const _hoisted_18 = { class: "ellipsis" }
const _hoisted_19 = { class: "row no-wrap items-center q-gutter-x-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_iap_chip = _resolveComponent("iap-chip")!
  const _component_iuf_select = _resolveComponent("iuf-select")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_iuf_avatar = _resolveComponent("iuf-avatar")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_highlighted_text = _resolveComponent("highlighted-text")!
  const _component_user_chip = _resolveComponent("user-chip")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_dialog_skeleton = _resolveComponent("dialog-skeleton")!

  return (_openBlock(), _createBlock(_component_dialog_skeleton, {
    "confirm-label": _ctx.isEdit ? _ctx.t('ACTION.CONFIRM') : _ctx.t('ACTION.CREATE'),
    loading: _ctx.loading,
    title: _ctx.isEdit ? _ctx.t('TITLE.UPDATE', { object: _ctx.t('MEETING.LOW.SING') }) : _ctx.t('TITLE.CREATE', { object: _ctx.t('MEETING.LOW.SING') }),
    onCancel: _ctx.cancel,
    onConfirm: _ctx.onSubmit,
    "disable-confirm": _ctx.disableSubmit,
    "disable-confirm-message": _ctx.canSubmit,
    ref: "dialog"
  }, {
    content: _withCtx(() => [
      _createVNode(_component_q_card, { class: "bg-white" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_form, {
            id: "meeting-form",
            ref: "meetingForm"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "column q-mx-md" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_input, _mergeProps({ autofocus: "" }, _ctx.INPUT_LG, {
                    modelValue: _ctx.meetingTitle,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.meetingTitle) = $event)),
                    "label-slot": "",
                    class: "full-width",
                    placeholder: _ctx.t('MEETING_NAME_PLACEHOLDER'),
                    rules: [(val) => val?.trim().length > 0 && val?.trim().length <= _ctx.MAX_LENGTH.MEETING.TITLE]
                  }), {
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('MEETING_TITLE')) + " ", 1),
                      _hoisted_1
                    ]),
                    error: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: _ctx.ICONS_NAME.WARNING_SOLID
                      }, null, 8, ["name"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.t(`MEETING_TITLE_${_ctx.meetingTitle?.trim().length ? 'LONG' : 'EMPTY'}`, {
                                            Meeting: _ctx.t('MEETING.CAP.SING'),
                                            x: _ctx.MAX_LENGTH.MEETING.TITLE
                                        })), 1)
                    ]),
                    _: 1
                  }, 16, ["modelValue", "placeholder", "rules"]),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_iuf_select, _mergeProps({
                        "add-btn-label": _ctx.t('CREATE_COMPANY'),
                        "allow-create": _ctx.canCreateCompany,
                        label: _ctx.t('MEETING_COMPANIES'),
                        loading: _ctx.loadingCompanies,
                        mandatory: "",
                        "model-value": _ctx.selectedCompanies,
                        "option-label": "name",
                        "option-value": "dobjId",
                        options: _ctx.companyOptions,
                        "placeholder-value": _ctx.t('SEARCH_PLACEHOLDER'),
                        "selected-item-slot": ""
                      }, _ctx.SELECT_MULTIPLE_LG_SEARCH, {
                        onAdd: _ctx.selectCompany,
                        onCreateValue: _ctx.createCompany,
                        onFilter: _ctx.searchCompanies,
                        onRemove: _ctx.removeCompany
                      }), {
                        "selected-item": _withCtx((scope) => [
                          _createVNode(_component_iap_chip, {
                            tooltip: "",
                            icon: _ctx.ICONS_NAME.COMPANY_OUTLINE,
                            label: scope.opt.name,
                            removable: "",
                            onRemove: ($event: any) => (scope.removeAtIndex(scope.index))
                          }, null, 8, ["icon", "label", "onRemove"])
                        ]),
                        _: 1
                      }, 16, ["add-btn-label", "allow-create", "label", "loading", "model-value", "options", "placeholder-value", "onAdd", "onCreateValue", "onFilter", "onRemove"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_iuf_select, _mergeProps({
                        label: _ctx.t('SELECT_PROJECTS', { leads: _ctx.t('LEAD.LOW.PLUR') }),
                        "option-label": "name",
                        "option-value": "dobjId",
                        options: _ctx.leadsOptions,
                        "placeholder-value": _ctx.t('SEARCH_PLACEHOLDER'),
                        "selected-item-slot": ""
                      }, _ctx.SELECT_MULTIPLE_LG_SEARCH, {
                        modelValue: _ctx.leadsSelected,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.leadsSelected) = $event)),
                        onFilter: _ctx.leadsSearch,
                        onRemove: _ctx.removeLead
                      }), {
                        "selected-item": _withCtx((scope) => [
                          _createVNode(_component_iap_chip, {
                            tooltip: "",
                            icon: _ctx.ICONS_NAME.FILE_OUTLINE,
                            label: scope.opt.name,
                            removable: "",
                            onRemove: ($event: any) => (scope.toggleOption(scope.opt))
                          }, null, 8, ["icon", "label", "onRemove"]),
                          _createVNode(_component_q_tooltip, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leadsSelected, (leadSelected, index) => {
                                return (_openBlock(), _createElementBlock("span", { key: index }, [
                                  _createTextVNode(" - " + _toDisplayString(leadSelected.name) + " ", 1),
                                  _hoisted_5
                                ]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 16, ["label", "options", "placeholder-value", "modelValue", "onFilter", "onRemove"])
                    ])
                  ]),
                  _createVNode(_component_q_separator, { class: "q-mt-lg" })
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, { class: "column q-mx-md q-pb-lg" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_date_picker, {
                          label: _ctx.t('MEETING_DATE'),
                          mandatory: "",
                          modelValue: _ctx.dueDate,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dueDate) = $event))
                        }, null, 8, ["label", "modelValue"])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_q_input, _mergeProps(_ctx.INPUT_LG, {
                          modelValue: _ctx.dueTime,
                          "onUpdate:modelValue": [
                            _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dueTime) = $event)),
                            _ctx.autofillTime
                          ],
                          "label-slot": "",
                          rules: [_ctx.rulesCommon],
                          "lazy-rules": "",
                          class: "q-input-time",
                          placeholder: _ctx.t('MEETING_TIME_PLACEHOLDER')
                        }), {
                          hint: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: _ctx.ICONS_NAME.INFO_CIRCLE_SOLID
                            }, null, 8, ["name"]),
                            _createTextVNode(" " + _toDisplayString(_ctx.t('MEETING_TIME_PLACEHOLDER')), 1)
                          ]),
                          label: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('MEETING_TIME')), 1)
                          ]),
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: _ctx.ICONS_NAME.CLOCK_OUTLINE
                            }, null, 8, ["name"])
                          ]),
                          error: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: _ctx.ICONS_NAME.WARNING_SOLID
                            }, null, 8, ["name"]),
                            _createElementVNode("span", null, _toDisplayString(_ctx.t('TIME_NOT_VALID')), 1)
                          ]),
                          _: 1
                        }, 16, ["modelValue", "rules", "onUpdate:modelValue", "placeholder"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_iuf_select, _mergeProps({
                        loading: _ctx.loadingTypes,
                        label: _ctx.t('TYPE_LABEL'),
                        options: _ctx.typeOptions,
                        removable: "",
                        "selected-item-slot": "",
                        maxlength: _ctx.MAX_LENGTH.PFCV.LABEL,
                        "placeholder-value": _ctx.t('SEARCH_PLACEHOLDER'),
                        modelValue: _ctx.type,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.type) = $event)),
                        "allow-create": _ctx.canCreateType && _ctx.isAllowedToCreate,
                        onCreateValue: _ctx.createType
                      }, _ctx.SELECT_SINGLE_LG_SEARCH, {
                        "option-value": "dobjId",
                        "option-label": "label",
                        onFilter: _ctx.typeSearch
                      }), {
                        "selected-item": _withCtx((scope) => [
                          _createVNode(_component_q_item_label, { class: "ellipsis" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(scope.opt.label) + " ", 1),
                              _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.opt.label), 1)
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 1
                      }, 16, ["loading", "label", "options", "maxlength", "placeholder-value", "modelValue", "allow-create", "onCreateValue", "onFilter"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.hasConference ? 'col-3' : 'toggle-conference-margin')
                    }, [
                      _createElementVNode("span", _mergeProps({ class: "text-primary-darker" }, _ctx.TEXT_FORM_FIELD_LABEL), _toDisplayString(_ctx.t('CONFERENCE_TOGGLE_LABEL')), 17),
                      _createElementVNode("div", null, [
                        _createVNode(_component_q_toggle, {
                          modelValue: _ctx.hasConference,
                          "onUpdate:modelValue": [
                            _cache[5] || (_cache[5] = ($event: any) => ((_ctx.hasConference) = $event)),
                            _cache[6] || (_cache[6] = ($event: any) => (_ctx.conference = null))
                          ]
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _normalizeProps(_guardReactiveProps(_ctx.TEXT_CONTENT_BODY)), _toDisplayString(_ctx.hasConference ? _ctx.t('CHOICE.TRUE') : _ctx.t('CHOICE.FALSE')), 17)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ], 2),
                    _withDirectives(_createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_iuf_select, _mergeProps({
                        loading: _ctx.loadingConferences,
                        "allow-create": _ctx.canCreateConference,
                        label: _ctx.t('CONFERENCE_LABEL'),
                        mandatory: _ctx.hasConference,
                        options: _ctx.conferenceOptions,
                        "placeholder-value": _ctx.t('SEARCH_PLACEHOLDER'),
                        modelValue: _ctx.conference,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.conference) = $event))
                      }, _ctx.SELECT_SINGLE_LG_SEARCH, {
                        "label-slot": "",
                        "selected-item-slot": "",
                        "no-option-slot": "",
                        "option-value": "dobjId",
                        "option-label": "name",
                        "add-btn-label": _ctx.t('CREATE_CONFERENCE'),
                        onFilter: _ctx.conferencesSearch,
                        onCreateValue: _ctx.createConference
                      }), {
                        "selected-item": _withCtx((scope) => [
                          _createVNode(_component_iap_chip, {
                            tooltip: "",
                            label: scope.opt.name,
                            removable: "",
                            onRemove: ($event: any) => (scope.removeAtIndex(scope.index))
                          }, null, 8, ["label", "onRemove"])
                        ]),
                        _: 1
                      }, 16, ["loading", "allow-create", "label", "mandatory", "options", "placeholder-value", "modelValue", "add-btn-label", "onFilter", "onCreateValue"])
                    ], 512), [
                      [_vShow, _ctx.hasConference]
                    ])
                  ]),
                  (_ctx.showAttendeesSection)
                    ? (_openBlock(), _createBlock(_component_q_separator, {
                        key: 0,
                        class: _normalizeClass({ 'q-mt-md': _ctx.hasConference })
                      }, null, 8, ["class"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_ctx.showAttendeesSection)
                ? (_openBlock(), _createBlock(_component_q_card_section, {
                    key: 0,
                    class: "column q-mx-md"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_iuf_select, _mergeProps({
                        label: _ctx.t('MEETING_ATTENDEES'),
                        loading: _ctx.loadingOptions,
                        options: _ctx.options,
                        "placeholder-value": _ctx.t('SEARCH_PLACEHOLDER'),
                        modelValue: _ctx.selectedMembers,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedMembers) = $event))
                      }, _ctx.SELECT_MULTIPLE_LG, {
                        onFilter: _ctx.searchOptions,
                        onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.searchInput.length ? _ctx.searchOptions : ''), ["enter"])),
                        onAdd: _ctx.selectMember,
                        onRemove: _ctx.unselectMember,
                        id: "meetingAddAttendeeSearch",
                        maxlength: _ctx.MAX_LENGTH.CONTACT.FIRST_NAME,
                        "no-dropdown-icon": "",
                        "label-slot": "",
                        "selected-item-slot": "",
                        "option-label": _ctx.getMemberLabel,
                        "option-value": "selectKey",
                        "allow-create": _ctx.isSearchingContacts,
                        "add-btn-label": _ctx.t('ADD'),
                        "creation-message": _ctx.afterMessage,
                        onCreateValue: _ctx.openCreateContactPopup,
                        ref: "meetingAddAttendeeSearch",
                        "use-input": ""
                      }), {
                        prepend: _withCtx(() => [
                          _createVNode(_component_q_icon, _mergeProps({
                            name: _ctx.ICONS_NAME.SEARCH_OUTLINE
                          }, _ctx.ICON_PROPS.BTN_SM), null, 16, ["name"])
                        ]),
                        option: _withCtx((scope) => [
                          (scope.opt['@type'] === _ctx.DataType.PrivateContact || scope.opt['@type'] === _ctx.DataType.InternalContact)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 0,
                                side: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_iuf_avatar, {
                                    "data-type": scope.opt['@type'] === _ctx.DataType.PrivateContact ? _ctx.DataType.PrivateContact : _ctx.DataType.InternalContact,
                                    object: scope.opt,
                                    text: scope.opt.firstName[0] + scope.opt.lastName[0],
                                    field: "avatar",
                                    size: "md"
                                  }, null, 8, ["data-type", "object", "text"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (scope.opt['@type'] === _ctx.DataType.PrivateContact || scope.opt['@type'] === _ctx.DataType.InternalContact)
                            ? (_openBlock(), _createBlock(_component_q_item_section, { key: 1 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, _mergeProps({ lines: 1 }, _ctx.TEXT_CONTENT_BODY, { class: "q-ml-xs ellipsis flex items-center" }), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_highlighted_text, {
                                        label: scope.opt.dobjPrettifiedBusinessWiseId,
                                        "text-filter": _ctx.searchInput
                                      }, null, 8, ["label", "text-filter"]),
                                      (scope.opt['@type'] === _ctx.DataType.InternalContact && scope.opt.user)
                                        ? (_openBlock(), _createBlock(_component_user_chip, {
                                            key: 0,
                                            "user-id": scope.opt.user,
                                            class: "internal-user-differenciator"
                                          }, null, 8, ["user-id"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1040)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (scope.opt['@type'] === _ctx.DataType.UserTenantAccess)
                            ? (_openBlock(), _createBlock(_component_q_item_section, {
                                key: 2,
                                side: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_iuf_avatar, {
                                    "data-type": _ctx.userProfileDataType,
                                    object: scope.opt.user['@userProfiles'][0],
                                    text: scope.opt.user['@userProfiles'][0].firstName[0] + scope.opt.user['@userProfiles'][0].lastName[0],
                                    field: "avatar",
                                    size: "sm"
                                  }, null, 8, ["data-type", "object", "text"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (scope.opt['@type'] === _ctx.DataType.UserTenantAccess)
                            ? (_openBlock(), _createBlock(_component_q_item_section, { key: 3 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, _mergeProps({ lines: 1 }, _ctx.TEXT_CONTENT_BODY, { class: "q-ml-sm ellipsis flex items-center" }), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_highlighted_text, {
                                        label: scope.opt.user['@userProfiles'][0].dobjPrettifiedBusinessWiseId,
                                        "text-filter": _ctx.searchInput
                                      }, null, 8, ["label", "text-filter"]),
                                      _createVNode(_component_user_chip, {
                                        class: "internal-user-differenciator",
                                        "user-id": scope.opt.user.dobjId
                                      }, null, 8, ["user-id"])
                                    ]),
                                    _: 2
                                  }, 1040)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        "selected-item": _withCtx((scope) => [
                          (scope.opt['@type'] === _ctx.DataType.PrivateContact || scope.opt['@type'] === _ctx.DataType.InternalContact)
                            ? (_openBlock(), _createBlock(_component_q_chip, {
                                key: 0,
                                removable: "",
                                onRemove: ($event: any) => (_ctx.unselectMember(scope.opt))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_iuf_avatar, {
                                    class: "selected-avatar",
                                    "data-type": scope.opt['@type'] === _ctx.DataType.PrivateContact ? _ctx.DataType.PrivateContact : _ctx.DataType.InternalContact,
                                    object: scope.op,
                                    text: scope.opt.firstName[0] + scope.opt.lastName[0],
                                    field: "avatar",
                                    size: "xs"
                                  }, null, 8, ["data-type", "object", "text"]),
                                  _createElementVNode("span", _hoisted_11, _toDisplayString(scope.opt.dobjPrettifiedBusinessWiseId || scope.opt['@type']), 1),
                                  _createVNode(_component_q_tooltip, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(scope.opt.dobjPrettifiedBusinessWiseId), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onRemove"]))
                            : (scope.opt['@type'] === _ctx.DataType.UserTenantAccess)
                              ? (_openBlock(), _createBlock(_component_q_chip, {
                                  key: 1,
                                  removable: _ctx.userAttendees.length > 1 || !_ctx.isPrivate,
                                  onRemove: ($event: any) => (_ctx.unselectMember(scope.opt))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_iuf_avatar, {
                                      class: "selected-avatar",
                                      "data-type": _ctx.userProfileDataType,
                                      object: scope.opt.user['@userProfiles'][0],
                                      text: scope.opt.user['@userProfiles'][0].firstName[0] + scope.opt.user['@userProfiles'][0].lastName[0],
                                      field: "avatar",
                                      size: "xs"
                                    }, null, 8, ["data-type", "object", "text"]),
                                    _createElementVNode("span", _hoisted_12, _toDisplayString(scope.opt.user['@userProfiles'][0].dobjPrettifiedBusinessWiseId), 1),
                                    _createVNode(_component_q_tooltip, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(scope.opt.user['@userProfiles'][0].dobjPrettifiedBusinessWiseId), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["removable", "onRemove"]))
                              : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 16, ["label", "loading", "options", "placeholder-value", "modelValue", "onFilter", "onAdd", "onRemove", "maxlength", "option-label", "allow-create", "add-btn-label", "creation-message", "onCreateValue"]),
                      (_ctx.selectedMembers.length > 0)
                        ? (_openBlock(), _createBlock(_component_q_list, {
                            key: 0,
                            class: "q-pt-md"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.contactAttendees.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createVNode(_component_q_item, { dense: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_section, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_label, _mergeProps({ class: "ellipsis" }, _ctx.TEXT_CARD_BODY), {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.t('EXTERNAL')) + " (" + _toDisplayString(_ctx.contactAttendees.length) + ") ", 1)
                                              ]),
                                              _: 1
                                            }, 16)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactsSelected, (member, index) => {
                                      return (_openBlock(), _createBlock(_component_q_item, _mergeProps({
                                        class: "attendee-item",
                                        dense: ""
                                      }, _ctx.BORDERLESS_ITEM, { key: index }), {
                                        default: _withCtx(() => [
                                          _createVNode(_component_iuf_avatar, _mergeProps({
                                            "data-type": _ctx.DataType.PrivateContact,
                                            object: member,
                                            text: member.firstName[0] + member.lastName[0],
                                            field: "avatar"
                                          }, _ctx.AVATAR_PROPS.USER), null, 16, ["data-type", "object", "text"]),
                                          _createVNode(_component_q_item_section, { class: "q-ml-sm" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_item_label, {
                                                lines: 1,
                                                class: "text-primary-darker attendee-option"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("span", _hoisted_14, _toDisplayString(member.firstName) + " " + _toDisplayString(member.lastName), 1),
                                                  _createVNode(_component_q_tooltip, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(member.firstName) + " " + _toDisplayString(member.lastName), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_q_item_section, { side: "" }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_15, [
                                                _createVNode(_component_q_btn, _mergeProps({
                                                  onClick: ($event: any) => (_ctx.unselectMember(member)),
                                                  class: "q-mr-xs"
                                                }, _ctx.BTN_SECONDARY_MD), {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_q_icon, {
                                                      name: _ctx.ICONS_NAME.TIMES_OUTLINE,
                                                      color: "negative"
                                                    }, null, 8, ["name"])
                                                  ]),
                                                  _: 2
                                                }, 1040, ["onClick"]),
                                                _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.t('ADD_MEMBERS_DIALOG.DESELECT_MEMBER_TOOLTIP')), 1)
                                                  ]),
                                                  _: 1
                                                }, 16)
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1040))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_q_item, {
                                dense: "",
                                class: "q-mt-sm"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      (_ctx.usersSelected.length > 0)
                                        ? (_openBlock(), _createBlock(_component_q_item_label, _mergeProps({
                                            key: 0,
                                            class: "ellipsis"
                                          }, _ctx.TEXT_CARD_BODY), {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.t('INTERNAL')) + " (" + _toDisplayString(_ctx.usersSelected.length) + ") ", 1)
                                            ]),
                                            _: 1
                                          }, 16))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersSelected, (member, index) => {
                                return (_openBlock(), _createBlock(_component_q_item, _mergeProps({
                                  class: "attendee-item",
                                  dense: ""
                                }, _ctx.BORDERLESS_ITEM, { key: index }), {
                                  default: _withCtx(() => [
                                    (member['@type'] === _ctx.IufDataType.UserTenantAccess)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createVNode(_component_iuf_avatar, _mergeProps({
                                            "data-type": _ctx.userProfileDataType,
                                            object: member.user['@userProfiles'][0],
                                            text: member.user['@userProfiles'][0].firstName[0] + member.user['@userProfiles'][0].lastName[0],
                                            field: "avatar"
                                          }, _ctx.AVATAR_PROPS.USER), null, 16, ["data-type", "object", "text"]),
                                          _createVNode(_component_q_item_section, { class: "q-ml-sm" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_item_label, {
                                                lines: 1,
                                                class: "text-primary-darker attendee-option flex items-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("span", _hoisted_16, _toDisplayString(member.user['@userProfiles'][0].dobjPrettifiedBusinessWiseId), 1),
                                                  _createVNode(_component_q_tooltip, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(member.user['@userProfiles'][0].dobjPrettifiedBusinessWiseId), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_user_chip, {
                                                    class: "internal-user-differenciator",
                                                    "user-id": _ctx.getUserId(member)
                                                  }, null, 8, ["user-id"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_q_item_section, { side: "" }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_17, [
                                                _createVNode(_component_q_btn, _mergeProps({
                                                  disable: _ctx.userAttendees.length <= 1 && _ctx.isPrivate,
                                                  onClick: ($event: any) => (_ctx.unselectMember(member)),
                                                  class: "q-mr-xs"
                                                }, _ctx.BTN_SECONDARY_MD), {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_q_icon, {
                                                      name: _ctx.ICONS_NAME.TIMES_OUTLINE,
                                                      color: "negative"
                                                    }, null, 8, ["name"])
                                                  ]),
                                                  _: 2
                                                }, 1040, ["disable", "onClick"]),
                                                (_ctx.userAttendees.length <= 1 && _ctx.isPrivate)
                                                  ? (_openBlock(), _createBlock(_component_q_tooltip, _normalizeProps(_mergeProps({ key: 0 }, _ctx.TOOLTIP_PROPS)), {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('ADD_MEMBERS_DIALOG.UNSELECT_MEMBER_TOOLTIP')), 1)
                                                      ]),
                                                      _: 1
                                                    }, 16))
                                                  : (_openBlock(), _createBlock(_component_q_tooltip, _normalizeProps(_mergeProps({ key: 1 }, _ctx.TOOLTIP_PROPS)), {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.t('ADD_MEMBERS_DIALOG.DESELECT_MEMBER_TOOLTIP')), 1)
                                                      ]),
                                                      _: 1
                                                    }, 16))
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createVNode(_component_iuf_avatar, _mergeProps({
                                            "data-type": _ctx.DataType.InternalContact,
                                            object: member,
                                            text: member.firstName[0] + member.lastName[0],
                                            field: "avatar"
                                          }, _ctx.AVATAR_PROPS.USER), null, 16, ["data-type", "object", "text"]),
                                          _createVNode(_component_q_item_section, { class: "q-ml-sm" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_item_label, {
                                                lines: 1,
                                                class: "text-primary-darker attendee-option flex items-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("span", _hoisted_18, _toDisplayString(member.firstName) + " " + _toDisplayString(member.lastName), 1),
                                                  _createVNode(_component_q_tooltip, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(member.firstName) + " " + _toDisplayString(member.lastName), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  (member.user)
                                                    ? (_openBlock(), _createBlock(_component_user_chip, {
                                                        key: 0,
                                                        class: "internal-user-differenciator",
                                                        "user-id": _ctx.getUserId(member)
                                                      }, null, 8, ["user-id"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_q_item_section, { side: "" }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_19, [
                                                _createVNode(_component_q_btn, _mergeProps({
                                                  onClick: ($event: any) => (_ctx.unselectMember(member)),
                                                  class: "q-mr-xs"
                                                }, _ctx.BTN_SECONDARY_MD), {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_q_icon, {
                                                      name: _ctx.ICONS_NAME.TIMES_OUTLINE,
                                                      color: "negative"
                                                    }, null, 8, ["name"])
                                                  ]),
                                                  _: 2
                                                }, 1040, ["onClick"]),
                                                _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.t('ADD_MEMBERS_DIALOG.DESELECT_MEMBER_TOOLTIP')), 1)
                                                  ]),
                                                  _: 1
                                                }, 16)
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ], 64))
                                  ]),
                                  _: 2
                                }, 1040))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showAttendeesSection)
                ? (_openBlock(), _createBlock(_component_q_card_section, {
                    key: 1,
                    class: "q-pt-none"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_checkbox, _mergeProps({
                        disable: _ctx.userAttendees.length === 0
                      }, _ctx.CHECKBOX_PROPS, {
                        modelValue: _ctx.isPrivate,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isPrivate) = $event)),
                        class: "q-ml-xs"
                      }), {
                        default: _withCtx(() => [
                          _createElementVNode("span", _normalizeProps(_guardReactiveProps(_ctx.TEXT_CONTENT_BODY)), _toDisplayString(_ctx.t('MEETING_PRIVATE')), 17)
                        ]),
                        _: 1
                      }, 16, ["disable", "modelValue"]),
                      _withDirectives(_createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('MAKE_PRIVATE_BUTTON_TOOLTIP')), 1)
                        ]),
                        _: 1
                      }, 16), [
                        [_vShow, _ctx.userAttendees.length === 0]
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["confirm-label", "loading", "title", "onCancel", "onConfirm", "disable-confirm", "disable-confirm-message"]))
}